import { Component, OnInit } from '@angular/core';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
	settings={};
  constructor(private SettingService: HeaderBarComponent) { }

  ngOnInit() {
  	this.SettingService.callsettings((data) => {
        this.settings = data;
    });
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/contact/contact.component.ts